export enum EPartOfMap {
  alaska = 'alaska',
  lower48 = 'lower48',
  canada = 'canada',
  hawaii = 'hawaii',
  puertoRico = 'puertoRico',
}
